import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["labelForExpand", "inputs"];
import React from 'react';
import { InputGroup as InputGroupHoi, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'InputGroup');
function InputGroup(_ref) {
  let {
      labelForExpand = [],
      inputs
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const showInputsLabel = labelForExpand[0] ? t(labelForExpand[0]) : labelForExpand[0];
  const hideInputsLabel = labelForExpand[1] ? t(labelForExpand[1]) : labelForExpand[1];
  if (!inputs) return null;
  return /*#__PURE__*/React.createElement(InputGroupHoi, _extends({}, props, {
    className: classes.root,
    inputs: inputs,
    showInputsLabel: showInputsLabel,
    hideInputsLabel: hideInputsLabel,
    isFullWidth: true
  }));
}
export default InputGroup;